<div class="main-container">
  <ion-grid [fixed]="true" class="breadcrumbs-container">
    <ion-row>
      <ion-col
        data-cy="tm-note-header-desktop-breadcrumbs"
        *ngIf="
          platformService.platformType === platformService.platformEnum.desktop
        "
      >
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ng-container *ngIf="note">
          <div
            data-cy="tm-note-header-title-dates-text"
            class="summary-container"
          >
            <div class="text-summary">
              <h3>{{ note?.title }}</h3>
              <span class="dates-label"
                >{{ note?.updDate | date: 'MM/dd/yyyy':'Z' }} -
                {{ note?.expireDate | date: 'MM/dd/yyyy':'Z' }}</span
              >
            </div>
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ng-container *ngIf="note">
          <div
            data-cy="tm-note-header-description-text"
            class="description-container"
          >
            {{ note?.text }}
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
